import { useMediaQuery } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { Create, NumberInput, required, SelectInput, SimpleForm, TextInput, useNotify } from 'react-admin';
import { devises, has_role, modePayement } from '../references.js';

const  CreateDepense =(props,...rest) => {
    const notify = useNotify();
    const [fullname, setFullname] = useState('');

    //const [listUserByRole, setListUserByRole] = useState();
    //const [disabledSaveButton, setDisabledSaveButton] = useState(true);
    const [role, setRole] = useState();
    const isSmall = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const { permissions } = props;

   useEffect(() => {
       
        setFullname(localStorage.getItem('fullname'));
        //setRole('ROLE_MANAGER');
        /*
        fetch(process.env.REACT_APP_URL+'/user/getUserByRoles', { method: 'GET',
                headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json;charset=UTF-8',
                        "Authorization": "Bearer "+ localStorage.getItem('token')
                }
            }
        ).then(json)
        .then((data) => {
            if(data.error){
                notify(data.message, 'warning');
                setListUserByRole([]);
            }  
            else setListUserByRole(data);
            //console.log(data);
            //setListUserByRole(data);
        }).catch((e) => {
            notify("Erreur lors du processus de récupération de la liste des agents !", 'warning')
        });
        */
    }, []);


  
    const typeChange=(event)=>{
        setRole(event.target.value);
    }
    
  return (
     
      <Create {...props}  title={'Création dépense - '+fullname}  >
        <SimpleForm  {...props}  submitOnEnter={true}  redirect="show" margin="none" >
                   
        { isSmall ?
              <TextInput {...rest} fullWidth source="titre" label="Titre"  validate={required()}/>
              :
              <TextInput {...rest} style={{width:'50%'}} source="titre" label="Titre" validate={required()}  />
          }

        {
         has_role(permissions,'ROLE_MANAGER')  ? 
          <>  
           { isSmall ?
         <SelectInput {...rest} fullWidth source="modeDep" label="Mode paiement dépense" validate={required()} choices={modePayement}  />:
         <SelectInput {...rest} style={{width:'50%'}} source="modeDep" label="Mode paiement dépense" validate={required()} choices={modePayement} />
           }
         </>
         : <TextInput  style={{display:'none'}} source="modeDep"  defaultValue="espece" />
        }
      
        { isSmall ?
              <SelectInput {...rest} fullWidth source="devise" label="Devise" validate={required()} choices={devises}  />
              :
              <SelectInput {...rest} style={{width:'50%'}} source="devise" label="Devise" validate={required()} choices={devises} />
          }

        { isSmall ?
              <NumberInput {...rest} fullWidth source="montant" label="Montant"  validate={required()}/>
              :
              <NumberInput {...rest} style={{width:'50%'}} source="montant" label="Montant" validate={required()}  />
          }
        
        { isSmall ?
              <TextInput {...rest} fullWidth source="commentaire" label="Commentaire"  />
              :
              <TextInput {...rest} style={{width:'50%'}} source="commentaire" label="Commentaire"   />
          }

        </SimpleForm>
    </Create> 
    );
};

export default CreateDepense;
